module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-3-139ebd314cd9ec2517f262e4b68b1c6b.svg";